import { render, staticRenderFns } from "./SelectBudget.vue?vue&type=template&id=6f623842&scoped=true&"
import script from "./SelectBudget.vue?vue&type=script&lang=js&"
export * from "./SelectBudget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f623842",
  null
  
)

export default component.exports